// Utilidad para calcular la fecha fin de un tour una vez escogida la fecha inicio
import moment from 'moment';

const calculateEndDate = (initDate, durationInDays) => {
    return moment(initDate).startOf('day').add(durationInDays, 'days');
};

export default calculateEndDate;


// WEBPACK FOOTER //
// ./src/utils/calculateEndDate.js